<template>
  <div v-if="show" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="closePopup" class="close-button">
        <img :src="require('@/assets/images/close-button.svg')" />
      </a>

      <div class="d-flex">
        <img
          v-if="imageSrc"
          :width="imageWidth"
          :height="imageHeight"
          :src="imageSrc"
          :alt="imageAlt"
        />

        <div class="p-3">
          <p v-if="title" v-html="title"></p>

          <p v-if="message" v-html="message" class="text-justify"></p>

          <div v-if="buttonText && buttonLink" class="text-center">
            <a
              :href="buttonLink"
              :class="buttonClass"
              target="_blank"
            >
              {{ buttonText }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnouncementPopup',

  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },

    buttonText: {
      type: String,
      default: ''
    },
    buttonLink: {
      type: String,
      default: '#'
    },
    buttonClass: {
      type: String,
      default: 'btn btn-themed text-white rounded-pill btn-mobile-app'
    },

    imageSrc: {
      type: String,
      default: ''
    },
    imageWidth: {
      type: [String, Number],
      default: 184
    },
    imageHeight: {
      type: [String, Number],
      default: 184
    },
    imageAlt: {
      type: String,
      default: 'Popup Image'
    },

    cookieName: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      show: false,
      autoCloseTimer: null
    };
  },

  mounted() {
    this.checkAndShowPopup();
  },

  methods: {
    checkAndShowPopup() {
      const sessionData = sessionStorage.getItem(this.sessionStorageKey);
      if (!sessionData) {
        this.show = true;
      }
    },
    closePopup() {
      this.show = false;
      sessionStorage.setItem(this.sessionStorageKey, 'true');
    },
  },
  computed: {
      sessionStorageKey() {
        return `announcement_${this.cookieName}`;
      }
  },
};
</script>

<style scoped>

.modal-popup {
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: auto !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  display: flex !important;
  justify-content: center !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.modal-popup-content {
  background-color: #fff;
  padding: 25px 35px;
  border-radius: 10px;
  position: relative;
  min-width: 670px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.3s ease-in;
  visibility: visible !important;
  opacity: 1 !important;
}
.close-button img {
  width: 24px;
  height: 24px;
}
.modal-popup-content .d-flex {
  align-items: center;
  gap: 20px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>
